import { Plugin } from "vue-fragment";
import "./plugins/vee-validate";
import "./plugins/fa-icons-plugin";
import store from "./store";

Vue.use(Plugin);

Vue.component("registration-modal", require("./ui/registration-modal/index").default);
Vue.component("agenda-list", require("./ui/agenda-list/index").default);
Vue.component("speakers-list", require("./ui/speakers-list/index").default);
Vue.component("event-checkbox", require("./ui/forms/event-checkbox").default);
Vue.component("event-radio", require("./ui/forms/event-radio").default);
Vue.component("event-spinner", require("./ui/shared/event-spinner").default);

new Vue({
  el: "#event-landing",
  store
});
